import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'
import Link from '../link'

export const StyledSingleLogoWrapper = styled.div`
  width: 100%;
`
export const StyledLogoLink = styled(Link)`
  display: block;
  position: relative;

  background: ${themeStyles.colors.darkGreys[4].main} !important;
  width: 100%;
  padding-top: 58%;
`

export const StyledIcon = styled.img`
  position: absolute;
  min-width: 30%;
  min-height: 30%;
  max-width: 70%;
  max-height: 70%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
